/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * PwC Intelligent Tax Analytics API
 * OpenAPI spec version: 1.0
 */

export type ProcessExportStatusEnum =
    (typeof ProcessExportStatusEnum)[keyof typeof ProcessExportStatusEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProcessExportStatusEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
} as const;
